module.exports = __webpack_public_path__ + "img/santa.19042564.png";